/**
 * XEP-0444: Message Reactions - Headless core
 */
import './plugin.js';
